// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"1f5aa427","255":"a9285fa0","298":"359e7f01","493":"586ac6db","677":"24ccc9d0","712":"1be81894","908":"8129ec24","925":"c8f2870a","951":"035421a3","960":"55af1ec9","966":"eba41b3f"}[chunkId] + ".chunk.js";
};